<div class="py-4 px-3">
  <div class="d-flex mb-3" *ngFor="let item of fileHistory">
    <img width="22" height="22" src="assets/images/user.svg" class="me-3 user-avatar" alt="user avatar" />
    <div class="media-body">
      <h5 class="m-0">
        {{ 'FILE_DETAILS_USER_PREFIX' | translate }} {{ item.modified_by.displayed_name }}
        {{ item.event_type }}
        {{ 'THIS_FILE_HINT' | translate }}
        <span *ngIf="item.shared_with"
          >{{ 'SHARE_WITH_HINT' | translate }}
          <span *ngFor="let person of item.shared_with.items">
            {{ person.displayed_name }}
          </span>
        </span>
        <span *ngIf="item.unshared_with">
          {{ 'SHARE_WITH_HINT' | translate }} {{ item.unshared_with.displayed_name }}
        </span>
      </h5>
      <div class="row">
        <div class="col">
          <span class="date">""</span>
        </div>
        <div class="col">
          <a href="#" (click)="$event.preventDefault()">
            <small>{{ 'FILE_SHARING_SETTINGS' | translate }}</small>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="px-3 pb-3">
  <span class="text-dark h3">
    {{ 'FILE_HISTORY_TOTAL' | translate }}
  </span>
  <p class="m-0">{{ 'FILE_HISTORY_DOWNLOADING' | translate }}: {{ downloadsCountCalc() }}</p>
  <p class="m-0">{{ 'FILE_HISTORY_VIEWING' | translate }}: {{ viewsCountCalc() }}</p>
</div>
